import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import {
  ConfirmDialogModal,
  ErrorDialogModal,
} from '@shared/components/Dialogs';
import BookingValuationChangesModal from './BookingValuationChangesModal';

const BookingValuationModalFlow = ({
  /** estado */
  showChangesModal,

  /** data */
  valuationChanges,
  id_integration,

  /** props usados por los renders internos */
  supplier,
  compare,
  id_product,
  total_nights,
  total_passangers,
  check_in,
  isFromHotelBookingStyled,

  /** acciones */
  onCancelChanges,
  onConfirmChanges,
  onAceptChanges,

  /** retry */
  showRetryModal,
  finalError,
  onRetry,
  onAbort,
  acceptOnly,
}) => {
  /** tooltips (antes estaban en CancelationFee) */
  const [usdUserTooltip, setUsdUserTooltip] = useState(null);
  const [priceTooltip, setPriceTooltip] = useState(null);

  const handleMouseEnter = (id, setFn) => setFn(id);
  const handleMouseLeave = setFn => setFn(null);

  const { business_types } = useSelector(store => store.pageConfiguration);
  const { data: integrations } = useSelector(store => store.integrations);

  const integration = integrations.find(i => +i.id === +id_integration);

  return (
    <>
      {/* 🟡 Cambios detectados */}
      {showChangesModal && (
        <BookingValuationChangesModal
          open
          valuationChanges={valuationChanges}
          business_types={business_types}
          integration={integration}
          supplier={supplier}
          compare={compare}
          id_product={id_product}
          total_nights={total_nights}
          total_passangers={total_passangers}
          check_in={check_in}
          isFromHotelBookingStyled={isFromHotelBookingStyled}
          usdUserTooltip={usdUserTooltip}
          setUsdUserTooltip={setUsdUserTooltip}
          priceTooltip={priceTooltip}
          setPriceTooltip={setPriceTooltip}
          handleMouseEnter={handleMouseEnter}
          handleMouseLeave={handleMouseLeave}
          onCancel={onCancelChanges}
          onConfirm={onConfirmChanges}
          onAcept={onAceptChanges}
          acceptOnly={acceptOnly}
        />
      )}

      {/* 🔁 Retry */}
      {showRetryModal && (
        <ConfirmDialogModal
          isOpen
          title="No pudimos verificar la habitación"
          text="No se pudo confirmar la disponibilidad ni las condiciones de la habitación."
          onConfirm={onRetry}
          onCancel={onAbort}
          cancelText="Volver a la búsqueda"
          confirmText="Reintentar"
          maxWidth="420px"
        />
      )}

      {/* 🔴 Error definitivo */}
      {finalError && (
        <ErrorDialogModal
          isOpen
          onClose={onAbort}
          title="No se pudo validar la disponibilidad"
          message="Es posible que la habitación ya no esté disponible o que haya un problema temporal con el proveedor."
          closeText="Volver a la búsqueda"
        />
      )}
    </>
  );
};

export default BookingValuationModalFlow;
